<div class="flex">
  <div class="dialog-container">
    <div class="dialog-header flex_sb">
      <div class="dialog-header-title">{{ 'REPORTS.NOT_TAL' | fallbackTranslate }}
        <div class="fs-16 fw-400 clr-333" *ngIf="billingCounterName" [innerHTML]="billingCounterInfo"></div>
      </div>
      <div class="dialog-header-cross flex-center" (click)="cancelClicked()">
        <img [src]="images.CROSS" class="img-20" />
      </div>
    </div>
    <hr class="hr-line"/>
    <ng-container *ngIf="!callManagerVerification">
      <div class="cashtally-dialog-container ta_center">
        <div class="cashtally-image-placeholder">
          <img [src]="images.CASH_TALLY" alt="cash-tally" />
          <p nz-text nzType="secondary">
            {{ 'REPORTS.CASH_TAL_DESC' | fallbackTranslate }}
          </p>
        </div>
      </div>
      <div class="footer flex_sb">
        <button class="go_back" (click)="callManagerVerification = true">
          {{ 'REPORTS.CALL_MANAGER' | fallbackTranslate }}
        </button>
        <button class="save" (click)="cancelClicked()">
          {{ 'REPORTS.RE_TALLY_AMOUNT' | fallbackTranslate }}
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="callManagerVerification">
      <div class="cashtally-dialog-container">
        <div class="flex align_center m-b-10 close-cashier-confirmation">
          <i nz-icon nzType="exclamation-circle" class="fs-20 m-r-10"></i>
          <p>
            {{ 'REPORTS.AMOUNT_DRAWER' | fallbackTranslate }}
          </p>
        </div>

        <nz-table
          class="m-t-30"
          #borderedTable
          nzBordered
          [nzData]="data?.cashNotTalliedData"
          nzFrontPagination="false"
          nzSize="middle"
        >
          <tbody>
            <tr *ngFor="let data of borderedTable?.data">
              <td nzAlign="left">
                <span nz-text nzType="secondary"
                  ><strong>{{ data?.name }}</strong></span
                >
              </td>
              <td nzAlign="center">
                <strong>{{ Currency }} {{ data?.amount || 0 }}</strong>
              </td>
            </tr>
          </tbody>
        </nz-table>
        <div class="verification-container ta_center">
          <custom-otp-input
            #ngOtpInput
            (onInputChange)="onOtpChange($event)"
            [config]="config"
            *ngIf="showOtpComponent"
            autocomplete="new-pass"
            [ngClass]="
              pinAuthLifecycle.success
                ? 'success-pin'
                : pinAuthLifecycle.wrong
                ? 'error-pin'
                : null
            "
          ></custom-otp-input>
          <p nz-text class="m-t-30 fs-16" *ngIf="pinAuthLifecycle?.reset">
            <strong>{{ 'REPORTS.PIN' | fallbackTranslate }}</strong>
          </p>
          <p
            nz-text
            class="m-t-30 fs-16 color-paid"
            *ngIf="pinAuthLifecycle?.success"
          >
            <strong>{{ 'REPORTS.AUTH' | fallbackTranslate }}</strong>
          </p>
          <p
            nz-text
            class="m-t-30 fs-16 color-unpaid {{ runningAnimation }}"
            *ngIf="pinAuthLifecycle?.wrong"
          >
            <strong>{{ 'REPORTS.WRONG_PIN' | fallbackTranslate }}</strong>
          </p>
          <p nz-text nzType="secondary" class="color-gray">
            {{ 'REPORTS.NEED_PIN' | fallbackTranslate }}
          </p>
        </div>
      </div>
    </ng-container>
  </div>
</div>
